<template>
  <div class="inte-card">
    <div class="inte-card-content">
      <div class="inte-card-title">我的积分</div>
      <div class="inte">
        <!-- <svg-icon iconClass="inte" size="20" /> -->
        <span>
         <UserSurplus></UserSurplus>
        </span>
      </div>
    </div>
    <div class="inte-card-actions">
     <router-link to="/myintegral">使用明细</router-link>
     <router-link to="/coupon-list">我的卡券</router-link>
    </div>
  </div>
</template>
<script>
import { payinte } from "@/api/pay";
export default {
  data() {
    return {
      integral: ''
    }
  }
}
</script>
<style scoped>
  .inte-card{
    width: 6.26rem;
    margin: 0.5rem auto;
    height: 2.64rem;
    background: url("~@/assets/bg/inte-card.png") 100%/100%  no-repeat;
    color: #fff;
    padding: 0 0.15rem;
  }
  .inte-card-content{
    border-bottom:1px solid #fff;
    padding-bottom: 0.4rem;
    text-align: center;
  }
  .inte-card-title {
    font-size: 0.32rem;
    padding: 0.15rem 0;
  }
  .inte{
    font-size:0.32rem
  }
  .inte span {
    font-size: 0.48rem;
  }
  .inte-card-actions{
    margin:0.1rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: center;
  }
  .inte-card-actions a {
    flex: 2;
    color: #fff;
    font-size: 0.26rem;
  }
</style>